export type SupportTranslator = (key: string) => string;

export const SUPPORT_CATEGORIES = [
  { value: 'organization-delete', i18nKey: 'common:support.categories.organizationDelete' },
  { value: 'billing', i18nKey: 'common:support.categories.billing' },
  { value: 'account', i18nKey: 'common:support.categories.account' },
  { value: 'data', i18nKey: 'common:support.categories.data' },
  { value: 'integration', i18nKey: 'common:support.categories.integration' },
  { value: 'bug', i18nKey: 'common:support.categories.bug' },
  { value: 'feature', i18nKey: 'common:support.categories.feature' },
  { value: 'other', i18nKey: 'common:support.categories.other' },
] as const;

export const SUPPORT_PRIORITIES = [
  { value: 'low', i18nKey: 'common:support.priorities.low' },
  { value: 'normal', i18nKey: 'common:support.priorities.normal' },
  { value: 'high', i18nKey: 'common:support.priorities.high' },
  { value: 'urgent', i18nKey: 'common:support.priorities.urgent' },
] as const;

const STATUS_KEYS: Record<string, string> = {
  open: 'system:support.statusOpen',
  in_progress: 'system:support.statusInProgress',
  resolved: 'system:support.statusResolved',
  closed: 'system:support.statusClosed',
};

export function supportCategoryLabel(t: SupportTranslator, value: string | null | undefined): string {
  const option = SUPPORT_CATEGORIES.find((item) => item.value === value);
  return t(option?.i18nKey ?? 'common:support.categories.other');
}

export function supportPriorityLabel(t: SupportTranslator, value: string | null | undefined): string {
  const option = SUPPORT_PRIORITIES.find((item) => item.value === value);
  return t(option?.i18nKey ?? 'common:support.priorities.normal');
}

export function supportStatusLabel(t: SupportTranslator, value: string | null | undefined): string {
  return t(STATUS_KEYS[value ?? ''] ?? 'system:support.statusUnknown');
}
